import React from 'react';
import AdminSignatures from '../components/AdminSignatures';

const SignaturesView = () => {
  return (
    <div className="space-y-8">
      <div className="flex justify-between items-center">
        <h1 className="text-3xl font-bold text-gray-900">Digital Signatures</h1>
      </div>

      <AdminSignatures />
    </div>
  );
};

export default SignaturesView;